<template>
<form @submit.prevent="submitForm">
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Transfer Project Ownership</p>
        </header>
        <section class="modal-card-body">
            <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                {{ errorMessage }}
            </b-notification>

            <b-field label="Name" horizontal>
                {{project.name}}
            </b-field>
            <b-field label="Owner" horizontal>
                {{project.ownerEmail}}
            </b-field>
            <b-field label="New Owner" horizontal>

                    <b-select
                        v-model="selectedTargetOwner"
                        placeholder="Select a new owner"
                        required
                        expanded
                        v-bind:loading="isLoading"
                    >
                        <option
                            v-for="(user) in availableUsers"
                            :key="user.id"
                            :value="user"
                        >{{ user.email }}</option>
                    </b-select>

            </b-field>

            <b-message type="is-warning" has-icon icon-size="is-small">
                Transferring this project will mean that the previous owner no longer has access to it.
                Please ensure that the new owner will be able access all of the required Netbase topics.
            </b-message>

        </section>
        <footer class="modal-card-foot">
            <button  type="button" class="button" @click="onCancelAction">Cancel</button>
            <button type="submit" class="button is-primary" :disabled="!selectedTargetOwner">Transfer Project</button>
        </footer>
    </div>
</form>
</template>

<script>
import _ from 'lodash';

import projectOwnershipService from '@/services/project-ownership-service.js';
import userService from '@/services/UserService.js';
// import constants from '@/constants.js'

import { projectServiceHelper } from '@/services/project-service-helper.js';

export default {
    name: 'ProjectTransferForm',
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            projectServiceHelper,
            errorMessage: '',
            availableUsers: [],
            selectedTargetOwner: null,
            isLoading: true
        };
    },
    async created () {
        try {
            let allUsersResponse = await userService.getUsers();

            if (allUsersResponse && allUsersResponse.data.length > 0) {
                this.availableUsers = _(allUsersResponse.data)
                    .filter(u => u.isActive && (u.role === 'Admin' || u.role === 'PowerUser' || u.role === 'LocalAdmin'))
                    .filter(u => u.email !== 'admin@publicismedia.com')
                    .sortBy('email')
                    .value();
            }
        } catch (error) {
            this.errorMessage = error.message;
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        async submitForm () {
            try {
                let transferredProject = Object.assign({}, this.project);
                transferredProject.userId = this.selectedTargetOwner.id;
                transferredProject.ownerEmail = this.selectedTargetOwner.email;
                await projectOwnershipService.transferOwnedProject(transferredProject);

                this.$emit('submitEvent', transferredProject);
                this.$parent.close();
            } catch (error) {
                if (error.response && error.response.data) {
                    this.errorMessage = error.response.data;
                } else {
                    this.errorMessage = error.message;
                }
            }
        },
        onCancelAction () {
            this.$parent.close();
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
    justify-content: flex-end;
}
</style>
